import * as React from 'react';
import { ELCLogger, TriggerType } from '@estee/elc-logging';
import { root, getServiceVersion } from '@estee/elc-universal-utils';

interface IProps {
    children: JSX.Element | null;
    serviceName: string;
    name: string;
}

interface IState {
    error?: Error;
}

export class ErrorBoundary extends React.Component<IProps, IState> {
    private logger: ELCLogger;

    constructor(props: IProps) {
        super(props);
        this.state = { error: undefined };
        this.logger = new ELCLogger({
            serviceName: props.serviceName,
            buid: root.buid || '',
            environment: root.env || '',
            serviceVersion: getServiceVersion(props.serviceName) || ''
        });
    }

    static getDerivedStateFromError(error?: Error) {
        return { error };
    }

    public componentDidCatch(error?: Error) {
        this.logger.error({
            triggerType: TriggerType.render,
            message: `Error caught in external view ${this.props.name}`,
            payload: {
                error: error,
                context: { serviceRegistry: root.ServiceRegistry }
            }
        });
    }

    public render() {
        return this.state.error ? null : this.props.children;
    }
}
